// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Mp-z","breadcrumbForward":"Np-z","breadcrumbBack":"Op-z","selected":"Pp-z"};